import { IAnnualReportDto } from '@modeso/types__aumico-lib-annualreport-be';
import { AnnualReportMetaInformationDTO } from '../../../../aumico-lib-annualreport-fe/src/lib';
import { ProjectMetaInformationDto } from './project-meta-information-dto.interface';

export interface AnnualReportDataDto {
    projectId: string | null;
    annualReportMetaInfo: AnnualReportMetaInformationDTO;
    projectMetaData: ProjectMetaInformationDto;
    annualReport: IAnnualReportDto;
}
